<template>
  <div>
    <feather-icon title="Booth Map" icon="MapIcon" :svgClasses="['h-7 w-7 cursor-pointer']" @click="boothMap" />
    <feather-icon title="Route Map" icon="MapPinIcon" :svgClasses="['h-7 w-7 ml-5 cursor-pointer']" @click="routeMap" />
  </div>
</template>

<script>
export default {
  name: 'CellRendererMap',
  computed: {
  },
  methods: {
    boothMap(){
      this.$router.push({ name: "boothmaps", params: {  mid: this.params.data.ID } })
    },
    routeMap(){
      this.$router.push({ name: "rootmaps", params: {  mid: this.params.data.ID } })
    }
  }
}
</script>
